import getStore from '../store/store';
import { mutator } from 'satcheljs';
import {
    setLastEnterCalendarTab,
    resetCalendarTabDropViewState,
    setDayViewDropTime,
    setShowDayDropHint,
} from '../actions/timePanelDndStoreActions';
import { createDropViewState } from 'owa-dnd';

mutator(setLastEnterCalendarTab, actionMessage => {
    getStore().lastDragOverHeader = actionMessage.lastTime;
});

mutator(resetCalendarTabDropViewState, () => {
    getStore().calendarTabDropViewState = createDropViewState();
});

mutator(setShowDayDropHint, actionMessage => {
    getStore().shouldShowHoverDayDrop = actionMessage.shouldShow;
});

mutator(setDayViewDropTime, ({ dayViewDropTime }) => {
    getStore().dayViewDropTime = dayViewDropTime;
});
